import React from 'react'
type PropsType = {
    pkg: string,
    img: string
}
const Belt = ({ pkg, img }: PropsType) => {
    return (
        <div className="h-[60vh] w-full relative bg-red-500">
            <div className="h-full w-full absolute bg-gradient-to-t from-gray-900 to-gray-500 opacity-80"></div>
            <img
                src={img}
                alt=""
                srcSet=""
                className="h-full w-full object-cover"
            />
            <div className="container mx-auto px-4 lg:px-8 text-center relative flex flex-col items-center justify-center">
                <div className="bottom-16 text-primary-light-200 -mt-[50vh]">
                    <h1 className="text-lg font-semibold uppercase text-white">
                        Package Details
                    </h1>
                    <h1 className="text-4xl font-bold capitalize mt-4">{pkg}</h1>
                </div>
            </div>
        </div>
    )
}

export default Belt